import React from 'react'
import { Loader } from '@web/walter-ui-kit'

function SendPageSkeleton() {
    return (
        <div className="flex flex-col">
            <Loader width="100%" height={64} borderRadius="s" />

            <div className="flex gap-2 mt-5 mb-4">
                <div className="flex-1 max-w-[160px]">
                    <Loader width="100%" height={36} borderRadius="s" />
                </div>
                <div className="flex-1 max-w-[160px]">
                    <Loader width="100%" height={36} borderRadius="s" />
                </div>
            </div>

            <div className="mb-4">
                <Loader width="100%" height={62} borderRadius="m" />
            </div>

            <div className="mb-4">
                <Loader width="100%" height={64} borderRadius="s" />
            </div>

            <div className="mb-8">
                <Loader width="100%" height={62} borderRadius="m" />
            </div>

            <div className="flex flex-col gap-4 mb-8">
                <div className="flex justify-between">
                    <Loader width={94} height={20} />
                    <Loader width={40} height={20} />
                </div>
                <div className="flex justify-between">
                    <Loader width={94} height={20} />
                    <Loader width={40} height={20} />
                </div>
                <div className="flex justify-between">
                    <Loader width={94} height={20} />
                    <Loader width={40} height={20} />
                </div>
            </div>

            <Loader width="100%" height={52} borderRadius="m" />
        </div>
    )
}

export default SendPageSkeleton
